export default __webpack_public_path__ + "static/media/1.0decb0f9.jpg";